function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "c",
  gradientUnits: "userSpaceOnUse",
  x1: 534.3,
  y1: 433.2,
  x2: 998.1,
  y2: 433.2
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.02
})), React.createElement("linearGradient", {
  y2: 433.2,
  x2: 998.1,
  y1: 433.2,
  x1: 534.3,
  gradientUnits: "userSpaceOnUse",
  id: "d",
  xlinkHref: "#c"
}), React.createElement("pattern", {
  patternTransform: "matrix(10 0 0 10 -2019.007 -304.36)",
  id: "b",
  xlinkHref: "#a"
}), React.createElement("pattern", {
  patternUnits: "userSpaceOnUse",
  width: 2,
  height: 1,
  patternTransform: "scale(10)",
  id: "a"
}, React.createElement("path", {
  d: "M0-.5h1v2H0z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M931.7 998.3c36.5 0 66.4-29.4 66.4-65.4V265.8c0-36-29.9-65.4-66.4-65.4H283.6l260.1 797.9z",
  fill: "#dbdbdb"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M931.7 230.4c9.7 0 18.9 3.8 25.8 10.6 6.8 6.7 10.6 15.5 10.6 24.8v667.1c0 9.3-3.7 18.1-10.6 24.8-6.9 6.8-16.1 10.6-25.8 10.6H565.5L324.9 230.4h606.8m0-30H283.6l260.1 797.9h388c36.5 0 66.4-29.4 66.4-65.4V265.8c0-36-29.9-65.4-66.4-65.4z",
  fill: "#dcdcdc"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4ba3c7",
  d: "M714.4 809.8H482.3l61.4 188.5z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M591.744 524.936h157.439",
  fill: "none",
  stroke: "#5a7788",
  strokeWidth: 10,
  strokeLinecap: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#5a7788",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "fill markers stroke",
  d: "M591.672 524.936h80.327v80.327h-80.327z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M591.672 524.936v80.327L672 524.936z",
  fill: "#5a7788"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M749.183 492.857v173.434",
  fill: "none",
  stroke: "#5a7788",
  strokeWidth: 10
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M749.183 666.29l-53.84 131.001m53.84-131.001l53.84 131.001M884.233 657.611l-135.12-135.12",
  fill: "none",
  stroke: "#5a7788",
  strokeWidth: 10,
  strokeLinecap: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#5a7788",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "fill markers stroke",
  d: "M884.284 657.661l-56.8-56.8-56.8 56.8 56.8 56.8z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M884.283 657.661l-56.8 56.8v-113.6z",
  fill: "#5a7788"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M795.416 446.624a46.233 46.233 0 01-46.233 46.233 46.233 46.233 0 01-46.234-46.232 46.233 46.233 0 0146.232-46.234 46.233 46.233 0 0146.235 46.23",
  fill: "none",
  stroke: "#5a7788",
  strokeWidth: 8.096,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "fill markers stroke"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.4 0C29.9 0 0 29.9 0 66.5v677c0 36.5 29.9 66.4 66.4 66.4h648.1L454.4 0z",
  fill: "#81d4fa"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M534.3 200.4h397.4c36.5 0 66.4 29.4 66.4 65.4V666z",
  fill: "url(#d)"
});

var SvgSemaphore = function SvgSemaphore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 998.1 998.3",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 144.427,
    y: 561.906,
    fontWeight: 400,
    fontSize: 40,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0,
    fillOpacity: 0.863
  }, React.createElement("tspan", {
    x: 144.427,
    y: 561.906,
    style: {
      InkscapeFontSpecification: "'Roboto, Medium'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    fontWeight: 500,
    fontSize: 440,
    fontFamily: "Roboto"
  }, "S")));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSemaphore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/semaphore.a38b0f40.svg";
export { ForwardRef as ReactComponent };